import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import PageShell from '@/components/site/PageShell';
import PageHero from '@/components/site/PageHero';
import Comparison from '@/components/site/Comparison';
import ClosingCTA from '@/components/site/ClosingCTA';

const COPY = {
  it: {
    eyebrow: 'Perché sceglierci',
    title_a: 'Non un altro gestionale.',
    title_b: 'Ore recuperate, settimana dopo settimana.',
    subtitle:
      'La differenza non è una feature in più. È che ogni funzione parte dal flusso reale di uno studio oculistico — visita, referto, follow-up, fatturazione. Confronta voce per voce: dove Prime Vision conta davvero, lo vedi al primo sguardo.',
  },
  en: {
    eyebrow: 'Why choose us',
    title_a: 'Not yet another EHR.',
    title_b: 'Recovered hours, week after week.',
    subtitle:
      'The difference is not one more feature. It\'s that every function starts from the real workflow of an eye-care practice — visit, report, follow-up, invoicing. Compare line by line: where Prime Vision actually moves the needle, you see it at a glance.',
  },
};

export const WhyPage = () => {
  const { locale } = useLanguage();
  const c = COPY[locale] || COPY.it;

  return (
    <PageShell title={c.eyebrow} testId="pv-why-page">
      <PageHero
        eyebrow={c.eyebrow}
        title_a={c.title_a}
        title_b={c.title_b}
        subtitle={c.subtitle}
        ctas={['demo', 'brochure', 'whatsapp']}
        source="why-hero"
        testId="pv-why-page-hero"
      />
      <Comparison compact />
      <ClosingCTA source="why-closing" />
    </PageShell>
  );
};

export default WhyPage;
